















































import Vue from "vue";
import AdminService from "@/services/adminService";
import { AdminUser } from "@/models/admin-user";

export default Vue.extend({
  props: ["username"],
  data() {
    return {
      email: "",
      given_name: "",
      admin: "0",
      adminUsers: [] as AdminUser[],
      updating: false,
      isLoaded: false
    };
  },
  async created() {
    await this.getList();
  },
  methods: {
    async getList() {
      this.isLoaded = true;
      const jwt = window.localStorage.getItem("jwt");
      if (jwt) {
        const adminService = new AdminService(jwt);
        const response = await adminService.getUsers();
        if (response && response.status == 200) {
          if (response.data) {
            this.adminUsers = response.data;
            const u = this.adminUsers.find(value => {
              return value.username === this.$props.username;
            });
            this.email = u!.email;
            this.given_name = u!.given_name;
            this.admin = u!.admin ? "1" : "0";
          }
        }
      }
      this.isLoaded = false;
    },
    async submit(e) {
      this.updating = true;
      e.preventDefault();
      const jwt = window.localStorage.getItem("jwt");
      if (jwt) {
        try {
          const adminService = new AdminService(jwt);
          const formData = new FormData();
          formData.append("username", this.username.trim());
          formData.append("email", this.email.trim());
          formData.append("admin", this.admin.trim());
          formData.append("given_name", this.given_name.trim());
          const response = await adminService.updateUsers(formData);
          if (response && response.status == 200) {
            if (response.data) {
              this.updating = false;
              alert("Update Successfully");
              await this.$router.push("/admin-users");
            }
          }
        } catch (error) {
          this.updating = false;
          alert(JSON.stringify(error.response.data));
        }
      }
    },
    async cancel() {
      await this.$router.push("/admin-users");
    }
  }
});
